export class DataLogin {

    constructor(
       public username : string,
       public password : string
    ) {}
}